module.exports = __webpack_public_path__ + "static/media/empresa6.08483287.jpg";